module.exports = __webpack_public_path__ + "static/patryk_zdunowski-2ed22d896e3c8e66d36b2a570b9cb283.png";